import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IProvider, IProviderCost } from "./models/providers";

@Injectable({
  providedIn: "root",
})
export class ProvidersService {
  private apiUrl: string = "/provider";
  public list: IProvider[] = [];

  constructor(private http: HttpClient) {}

  async getList() {
    return this.http
      .get(this.apiUrl)
      .toPromise()
      .then((response: IProvider[]) => {
        this.list = response;
        return response;
      });
  }

  async get(id: number) {
    return this.http.get(`${this.apiUrl}/${id}`).toPromise();
  }

  async delete(id: number) {
    return this.http
      .delete(`${this.apiUrl}/${id}`)
      .toPromise()
      .then(() => {
        this.getList();
      });
  }

  async create(data: IProvider) {
    return this.http.post(this.apiUrl, data).toPromise();
  }
  async edit(id: number, data: any) {
    return this.http.put(`${this.apiUrl}/${id}`, data).toPromise();
  }

  async addAddress(data: any = {}) {
    return this.http.post("/provider/address", data).toPromise();
  }

  async editAddress(address_id: number, data: any = {}) {
    return this.http.put(`/provider/address/${address_id}`, data).toPromise();
  }

  async deleteAddress(address_id: number) {
    return this.http.delete(`/provider/address/${address_id}`).toPromise();
  }

  async addReferent(data: any) {
    return this.http.post("/provider/referent", data).toPromise();
  }

  async editReferent(id: number, data: any = {}) {
    return this.http.put(`/provider/referent/${id}`, data).toPromise();
  }

  async deleteReferent(id: number) {
    return this.http.delete(`/provider/referent/${id}`).toPromise();
  }

  //Restituisce i costi di un fornitore
  async getProviderCosts(id: number, year: string) {
    return this.http.get<IProviderCost[]>(`/provider/analytics/${id}/${year}`).toPromise();
  }
}
